import { ApplicationEnvEnum } from "@/apis/model/ApplicationEnvEnum";
import { fhtWebGlobal, fhtCommonEnv } from "@/common/fhtGlobalEnv";
import "./index.scss";

if (fhtWebGlobal === null || fhtWebGlobal === void 0 ? void 0 : fhtWebGlobal.q) {
  var url = "http://www.fht360.com/Search/product/Fht1SearchRightAdvertisement";

  if (fhtCommonEnv.AppEnv == ApplicationEnvEnum.Production) {
    url = fhtCommonEnv.Hosts.FhtWebUrlRoot + "/web/Search/product/Fht1SearchRightAdvertisement";
  }

  $.ajax({
    url: url,
    data: {
      keyword: fhtWebGlobal.q
    },
    success: function success(result) {
      $.each(result, function (i, n) {
        $(".layout-front__secondary").append("<div class='layout-front__secondary-item'><a href='" + n.AdUrl + "' title='" + n.Title + "'><img class='layout-front__advertise' src='" + n.ImgUrl + "'></a></div>");
      });
    },
    dataType: "jsonp"
  });
}